module.exports = __webpack_public_path__ + "static/Baby_Build_My_Book-67ab8f0b8dba469f6bc8087c9941fce9.jpg";